export default __webpack_public_path__ + "static/media/DownIcon.661010e4.svg";